import { render, staticRenderFns } from "./CloseClaimForm.vue?vue&type=template&id=598391f4"
import script from "./CloseClaimForm.vue?vue&type=script&lang=ts"
export * from "./CloseClaimForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports